var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"uk-button uk-button-primary add-button",attrs:{"id":"add-button"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{attrs:{"uk-icon":"icon: plus"}}),_vm._v(" Add ")])}
var staticRenderFns = []

export { render, staticRenderFns }